function LinkRedundant() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>Adjacent links go to the same URL.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>When adjacent links go to the same location (such as a linked product image and an adjacent linked product name that go to the same product page) this results in additional navigation and repetition for keyboard and screen reader users.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>If possible, combine the redundant links into one link and remove any redundant text or alternative text (for example, if a product image and product name are in the same link, the image can usually be given alt="").</p>
    </blockquote>
  )
}

export default LinkRedundant